// components/sections/PersonalInformation.tsx
import React from 'react';
import { Registry, MaritalStatus } from '@/graphql/__generated__/onboarding';
import { useTranslations } from 'use-intl';
import TextSection from './TextSection';

interface PersonalInformationProps {
	registry: Registry;
	onChangeRequest: (
		e: React.ChangeEvent<HTMLInputElement>,
		section: string,
		field: string,
		value: any
	) => void;
	changesRequested: Array<{ section: string; field: string; value: any }>;
	cantRequestChangesFromFields: string[];
}

export const PersonalInformation: React.FC<PersonalInformationProps> = ({
	registry,
	onChangeRequest,
	changesRequested,
	cantRequestChangesFromFields
}) => {
	const t = useTranslations('RegistryDetails');

	const getMaritalStatusText = (status: MaritalStatus): string => {
		const statusMap: Record<MaritalStatus, string> = {
			[MaritalStatus.MARRIED_JOINT_PROPERTY]: t('MarriedJointProperty'),
			[MaritalStatus.SINGLE]: t('Single'),
			[MaritalStatus.MARRIED_SEPARATED_PROPERTY]: t('MarriedSeparatedProperty'),
			[MaritalStatus.FREE_UNION]: t('FreeUnion'),
			[MaritalStatus.DIVORCED]: t('Divorced'),
			[MaritalStatus.WIDOWED]: t('Widowed'),
			[MaritalStatus.SEPARATED]: t('Separated')
		};
		return statusMap[status] || t('Other');
	};

	return (
		<div className="space-y-3">
			<TextSection
				label="Names"
				value={registry.personalInformation?.names}
				field="Names"
				sectionName="PersonalInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="FirstLastName"
				value={registry.personalInformation?.firstLastName}
				field="FirstLastName"
				sectionName="PersonalInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="SecondLastName"
				value={registry.personalInformation?.secondLastName}
				field="SecondLastName"
				sectionName="PersonalInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="CURP"
				value={registry.personalInformation?.curp}
				field="Curp"
				sectionName="PersonalInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="MaritalStatus"
				value={
					registry.personalInformation?.maritalStatus
						? getMaritalStatusText(registry.personalInformation.maritalStatus)
						: null
				}
				field="MaritalStatus"
				sectionName="PersonalInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
			<TextSection
				label="HasChildren"
				value={registry.personalInformation?.hasChildren}
				field="HasChildren"
				sectionName="PersonalInformation"
				registryStatus={registry.registryStatus}
				onChangeRequest={onChangeRequest}
				changesRequested={changesRequested}
				cantRequestChangesFromFields={cantRequestChangesFromFields}
			/>
		</div>
	);
};

export default PersonalInformation;
